import Vue from 'vue'

const components = [
  'VMapCom',
  'ProjectInfoCom',
  'ContractorCom',
  'AttendanceFactCom',
  'InOutFactCom',
  'TimeCom',
  'ProjectPersonCom',
  'InsideCom',
  'VChartCom',
  'InOutPersonCom',
  'NoticeCom',
  'AIBehaviorAlertCom',
  'AIBehaviorAlertCom'
]

components.forEach((key) => {
  Vue.component(key, require(`./${key}/Component.vue`).default)
})

Vue.component(
  'ProjectInfoCom' + 'Attr',
  require(`./ProjectInfoCom/Attr.vue`).default
)
Vue.component(
  'ContractorCom' + 'Attr',
  require(`./ContractorCom/Attr.vue`).default
)
Vue.component(
  'AttendanceFactCom' + 'Attr',
  require(`./AttendanceFactCom/Attr.vue`).default
)
Vue.component('TimeCom' + 'Attr', require(`./TimeCom/Attr.vue`).default)
Vue.component(
  'InOutFactCom' + 'Attr',
  require(`./InOutFactCom/Attr.vue`).default
)
Vue.component(
  'AIBehaviorAlertCom' + 'Attr',
  require(`./AIBehaviorAlertCom/Attr.vue`).default
)
Vue.component('InsideCom' + 'Attr', require(`./InsideCom/Attr.vue`).default)
Vue.component(
  'ProjectPersonCom' + 'Attr',
  require(`./ProjectPersonCom/Attr.vue`).default
)
Vue.component('VChartCom' + 'Attr', require(`./VChartCom/Attr.vue`).default)
